import React from 'react'
import { Col, Row, Container } from 'react-bootstrap'
import Card from 'react-bootstrap/Card';
import backgroundImage from '../../assets/backgroundblur.jpeg';
function E2Eprocess1() {
    const containerStyle = {
        background: `url(${backgroundImage})center/cover no-repeat`, // specify the background image properties
        fontFamily: 'sans-serif',
        // set a minimum height to cover the entire viewport
        // minHeight: '80vh',

    };
    return (
        // </Container>
        <div style={containerStyle} className='d-flex flex-column justify-content-center align-items-center pt-5 '>
            <div className=" " >
                <div className="row " data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600" >
                    <div className='d-flex justify-content-center' id="e2eprocess">
                        <div className="col-lg-10 ">
                            <h5 style={{ fontSize: '28px', fontWeight: 'bold' }} className="title text-center">E2E Process </h5>
                            <p className="mt-2 text-center" style={{ fontSize: '15px', color: '#767676', textAlign: 'justify' }}>
                                An End-to-End workflow of a manufacturing company that streamlined its complex<br></br>
                                logistics and increased profitability.

                            </p>
                        </div>

                    </div>
                </div>
                <div className='d-flex align-items-center mt-4 ' style={{ minHeight: '55vh' }}>
                    <Row className='d-flex justify-content-center align-items-center '>
                        <Col lg={10} sm={12} md={10} className='d-flex justify-content-center'>
                            <img src={require('../../assets/e2e1.png')} alt="cart" style={{  }} className='img-fluid'></img>
                        </Col>
                        
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default E2Eprocess1